import { useMemo, useRef } from 'react';
import { useUnmount } from 'ahooks';
import { SVGPureIcon } from '@/ui';
import globalStore from '@/store/global';
import { observer } from 'mobx-react-lite';
import inputTypeStore from './input-type';

function ImageCard(props) {
  const {
    file,
    closeable,
    progress,
    onClose,
    onButtonClick,
    supportKnowledge,
    isMulti,
  } = props;
  const isUploaded = progress == 100;

  const containerRef = useRef(null);

  const src = useMemo(() => {
    return URL.createObjectURL(file);
  }, [file]);

  useUnmount(() => {
    URL.revokeObjectURL(src);
  });

  return (
    <div className={[
      'flex items-center h-50px gap-[8px]',
      (!supportKnowledge || isMulti) ? 'size-50px' : 'min-w-178px'
    ]}>
      <section ref={containerRef} className="relative group h-50px">
        <div className={[
          'relative inline-block size-50px rounded-8px overflow-hidden',
          'border-1px boder-solid border-black border-opacity-10',
        ]}>
          <img className="size-full object-cover rounded-8px" src={src} />
          {/* <div className="absolute inset-0 border-1px border-solid border-black border-opacity-10 pointer-events-none"></div> */}
        </div>

        {!isUploaded && (
          <div
            className={[
              'absolute left-0 bottom-0 size-full rounded-[6px]',
              'flex justify-center items-center',
              'bg-[rgba(0,0,0,.5)] text-[12px] text-white',
            ]}
          >
            {progress}%
          </div>
        )}

        <span
          className={[
            'absolute -top-[7px] -right-[7px]',
            'rounded-full p-[6px]',
            'bg-black bg-opacity-70 hover:bg-opacity-80',
            'cursor-pointer',
            'hidden',
            { 'group-hover:inline': closeable },
          ]}
          onClick={() => onClose?.(file)}
        >
          <SVGPureIcon name="close-8" className="size-8px text-white" />
        </span>
      </section>

      {isUploaded && (Array.from(inputTypeStore.tempFile)?.length == 1) && supportKnowledge && (
        <section className="flex flex-col gap-[6px]">
          <button
            className={[
              'px-[8px] h-22px rounded-[8px] text-[12px] leading-[22px]',
              globalStore.isDark
                ? 'bg-[#31313A] hover:bg-[#31313A] hover:bg-opacity-50 hover:text-opacity-70 text-white text-opacity-50'
                : 'bg-[rgba(0,0,0,0.03)] hover:bg-[rgba(0,0,0,0.03)] hover:text-opacity-70 text-black text-opacity-50',
            ]}
            onClick={() =>
              onButtonClick?.({
                type: 'describe-image',
                prompt: '解释这张图片',
              })
            }
          >
            解释这张图片
          </button>
          <button
            className={[
              'px-[8px] h-22px rounded-[8px] text-[12px] leading-[22px]',
              globalStore.isDark
                ? 'bg-[#31313A] hover:bg-[#31313A] hover:bg-opacity-50 hover:text-opacity-70 text-white text-opacity-50'
                : 'bg-[rgba(0,0,0,0.03)] hover:bg-[rgba(0,0,0,0.03)] hover:text-opacity-70 text-black text-opacity-50',
            ]}
            onClick={() =>
              onButtonClick?.({ type: 'ocr', prompt: '提取图中文字' })
            }
          >
            提取图中文字
          </button>
        </section>
      )}
    </div>
  );
}

export default observer(ImageCard);
